// mediaUtil.js

/**
 * 依據 url 判斷是什麼媒體類型
 * @param {string} url - 媒體連結
 * @returns { 'youtube' | 'facebook' | 'image' | 'video' | 'unknown' }
 */
export function getMediaType(url) {
    if (!url) return 'unknown'
  
    // 1. YouTube
    if (url.includes('youtube.com/') || url.includes('youtu.be/')) {
      return 'youtube'
    }
  
    // 2. Facebook reels / watch
    if (url.includes('facebook.com/reel/') || url.includes('facebook.com/watch')) {
      return 'facebook'
    }
  
    // 3. 圖片 (jpg/png/gif/webp) => e.g. .png / .jpg / .jpeg / .gif / .webp
    if (/\.(gif|png|jpe?g|webp)$/i.test(url)) {
      return 'image'
    }
  
    // 4. 規定 mp4 為本地影片
    if (/\.(mp4)$/i.test(url)) {
      return 'video'
    }
  
    // 5. 若無符合
    return 'unknown'
  }
  
  /**
   * 解析 YouTube url，取得影片 ID
   * @param {string} url
   * @returns {string} - 影片ID (若失敗就回空字串)
   */
  export function getYoutubeId(url) {
    if (!url) return ''
    // 可能有多種型態: "youtube.com/watch?v=xxx", "youtu.be/xxx"
    const match1 = url.match(/[?&]v=([^&#]+)/)  // ex. "?v=xxx"
    if (match1 && match1[1]) {
      return match1[1]
    }
    // 簡易處理 "youtu.be/xxxx"
    const match2 = url.match(/youtu\.be\/([^?&#]+)/)
    if (match2 && match2[1]) {
      return match2[1]
    }
    return ''
  }
  